import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '../lang/lang'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        appCfg: null,
        spin: {
            show: true,
            text: 'loading...',
        },
        error: null,
        cartNum: 0,
        headerTopKeywords: '',
        HTTP: '',
        memberInfo: '',
        pkgNums: 0,
        lang: 'en',
    },
    mutations: {
        setBaseUrl(state, baseUrl) {
            state.baseUrl = baseUrl
        },
        setSpin(state, text) {
            state.spin.text = text;
            state.spin.show = true;
        },
        spinClose(state) {
            state.spin.show = false;
        },
        setError(state, message) {
            state.error = message;
        },
        setCartNum(state, num) {
            state.cartNum = num;
        },
        setHeaderTopKeywords(state, keywords) {
            state.headerTopKeywords = keywords;
        },
        setHTTP(state, http) {
            state.HTTP = http;
        },
        changeLang(state, lang) {
            state.lang = lang;
            localStorage.setItem('lang', lang);
            i18n.locale = lang;
        }
    },
    actions :{
        // 获取个人信息
        getInfo({state}){
            state.HTTP.get('/member/Member/member_info').then((res) => {
                if (res.data.sts == 1) {
                    state.memberInfo = res.data.data;
                }
            })
        },
        // 获取转运包裹数量
        getPkgNum({state}) {
            state.HTTP.get('/package/package_forecast/get_pkg_sum').then((res) => {
                if (res.data.sts == 1) {
                    state.pkgNums = res.data.data.sum;
                }
            })
        },
    }
})

export function spinLoading(text) {
    return store.commit('setSpin', text);
}

export function closeSpinLoading() {
    return store.commit('spinClose');
}

export function setGlobalError(message) {
    return store.commit('setError', message);
}

export function closeError() {
    return store.commit('setError', null);
}

export default store
